import Repository from "./Repository";
import ReportsEmployeeDetailsResponse from "./response/ReportsEmployeeDetailResponse";
import AssignmentEmployeeResponse from "./response/AssignmentEmployeeResponse";
import ExecutiveReportRequest from "../types/Reports/ExecutiveReportRequest";
import { SetupReportOptions } from "../components/Reports/CompanySetup/ReportsCompanySetupOptions";
import CompanySetupEmployeeData from "../components/Reports/CompanySetup/CompanySetupEmployeeData";
import CompanySetupGroupData from "../components/Reports/CompanySetup/CompanySetupGroupData";
import CompanySetupAssignmentData from "../components/Reports/CompanySetup/CompanySetupAssignmentData";
import BaseResponse from "../types/BaseResponse";
import CompanySetupDocumentData from "../components/Reports/CompanySetup/CompanySetupDocumentData";
import SummaryCount from "../types/Reports/SummaryCount";
import ManagerAssignmentSummary from "../types/Reports/ManagerAssignmentSummary";
import QuestionReviewResponse from "./response/QuestionReviewResponse";

const resource = "/reporting";

export default {
  getQuestionReviewReport(companyId: string, fromDate : string | null, toDate : string | null) {
      var baseRequestPath = `${resource}/questionReviewReport/${companyId}`
      if(fromDate) {
        baseRequestPath += `?fromDate=${fromDate}`
      }
      if(toDate) {
        if(fromDate) {
          baseRequestPath += `&toDate=${toDate}`
        }
        else {
          baseRequestPath += `?toDate=${toDate}`
        }
      }
      return Repository.get<QuestionReviewResponse>(
        baseRequestPath
      );
  },
  getEmployeeDetail(companyId: string) {
    return Repository.get<ReportsEmployeeDetailsResponse>(
      `${resource}/employeedetail/${companyId}`
    );
  },
  getExecutiveReport(companyId: string, reportRequest: ExecutiveReportRequest) {
    return Repository.post<AssignmentEmployeeResponse>(
      `${resource}/executiveReport/${companyId}`,
      reportRequest
    );
  },
  getCompanySetupEmployees(
    companyId: string,
    reportOptions: SetupReportOptions
  ) {
    return Repository.post<BaseResponse<CompanySetupEmployeeData[]>>(
      `${resource}/companySetup/employee/${companyId}`,
      reportOptions
    );
  },
  getCompanySetupGroups(companyId: string, reportOptions: SetupReportOptions) {
    return Repository.post<BaseResponse<CompanySetupGroupData[]>>(
      `${resource}/companySetup/group/${companyId}`,
      reportOptions
    );
  },
  getCompanySetupAssignments(
    companyId: string,
    reportOptions: SetupReportOptions
  ) {
    return Repository.post<BaseResponse<CompanySetupAssignmentData[]>>(
      `${resource}/companySetup/assignment/${companyId}`,
      reportOptions
    );
  },
  getCompanySetupDocuments(
    companyId: string,
    reportOptions: SetupReportOptions
  ) {
    return Repository.post<BaseResponse<CompanySetupDocumentData[]>>(
      `${resource}/companySetup/document/${companyId}`,
      reportOptions
    );
  },
  getAssignmentSummary(fromDate: string) {
    return Repository.get<BaseResponse<SummaryCount[]>>(
      `${resource}/manager/assignmentsummary?fromDate=${fromDate}`
    );
  },
  getAssignmentSummaryByManager() {
    return Repository.get<BaseResponse<ManagerAssignmentSummary[]>>(
      `${resource}/assignment/summary/manager`
    );
  },
};
